import React, {Component} from 'react';
import {connect} from 'react-redux';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import CpdKpi from './kpiData';

class CpdKpiComponent extends Component {
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ReceivedAndDispatchedLinesKpi, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
  }

  render() {
    return (
      <CpdKpi seePriceSection={hasAccessPermission(this.props.permissions,
        resources.ReceivedAndDispatchedLinesKpi, scopes.Price)} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};

const {navigateTo} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
})(CpdKpiComponent);
